import { ImportantInfoCard } from "./importantInfoCard.component";
import { ApiSchemaCaregiver } from "../../../models/api";
import { CertificateListCard } from "./certificateListCard.component";

type Props = {
  data: ApiSchemaCaregiver | undefined;
  isValidating: boolean;
};

export const PersonalInformation = (props: Props) => (
  <div className="row gx-0 g-lg-2 g-md-2">
    <div className="col-md-6 col-lg-6 col-12 mb-3">
      <ImportantInfoCard {...props} />
    </div>
    <div className="col-md-6 col-lg-6 col-12 mb-1">
      <CertificateListCard {...props} />
    </div>
  </div>
);
